import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-visa-status-note-input',
  templateUrl: './visa-status-note-input.component.html',
  styleUrls: ['./visa-status-note-input.component.scss'],
})
export class VisaStatusNoteInputComponent implements OnInit {

  emitDataChanged!: (data: any) => void;
  data: string = '';

  constructor() { }

  ngOnInit() { }

  onDataChange(){
    this.emitDataChanged(this.data);
  }



}
